import { isMapActionCatalogIcon, MapActionConfigItem } from '@ivy-monorepo/shared'

/** Built-in icons, copied from the app's assets/icons/map_action_*.svg. */
export const builtInMapActionIconUrl = (key: MapActionConfigItem['key']) => `/images/map-actions/${key}.svg`

/** Catalog icons (MAP_ACTION_ICON_CATALOG), the same SVGs the app bundles. */
export const catalogMapActionIconUrl = (name: string) => `/images/map-actions/catalog/${name}.svg`

/** Same order as the app: uploaded SVG, then catalog icon, then built-in. */
export const resolveMapActionIconUrl = (item: Pick<MapActionConfigItem, 'key' | 'iconName' | 'iconUrl'>) =>
  item.iconUrl
  ?? (isMapActionCatalogIcon(item.iconName) ? catalogMapActionIconUrl(item.iconName) : builtInMapActionIconUrl(item.key))

type MapActionIconProps = {
  item: Pick<MapActionConfigItem, 'key' | 'iconName' | 'iconUrl'>
  size?: number
  /** `muted` = the app's sidebar gray (#C5C5C5), `white` = the selected pill. */
  tint?: 'muted' | 'white'
}

/**
 * Renders a filter icon tinted the way the app does (every opaque pixel takes
 * one color), via a CSS filter — a mask-image would need CORS on the bucket.
 */
const MapActionIcon = ({ item, size = 24, tint = 'muted' }: MapActionIconProps) => (
  <img
    className={`map-action-icon map-action-icon--${tint}`}
    src={resolveMapActionIconUrl(item)}
    width={size}
    height={size}
    alt=""
    draggable={false}
  />
)

export default MapActionIcon
